import React from 'react'

export default function VisiGiftMerchantRules() {
  return (
    <div>VisiGiftMerchantRules</div>
  )
}
